/**
 * @fileoverview Renderer for the 'complete' tool.
 * Displays completion content with detailed file attachment cards.
 */

'use client';

import { Markdown } from '@/components/ui';
import { DetailedAttachmentList, parseAttachments } from '../components';

interface CompleteRendererProps {
  /** Input containing text and attachments */
  input: {
    text?: string;
    content?: string;
    attachments?: string | string[];
  };
  /** Sandbox ID for file operations */
  sandboxId?: string;
}

/**
 * Renders the complete tool with detailed file cards.
 */
export function CompleteRenderer({ input, sandboxId }: CompleteRendererProps) {
  const completeText = input?.text || input?.content || '';
  const attachmentArray = parseAttachments(input?.attachments);

  if (!completeText && attachmentArray.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3 my-4">
      {completeText && (
        <div className="max-w-none break-words">
          <Markdown density="chat">{completeText}</Markdown>
        </div>
      )}
      {attachmentArray.length > 0 && (
        <DetailedAttachmentList attachments={attachmentArray} sandboxId={sandboxId} />
      )}
    </div>
  );
}
